import React from 'react'
import styles from './footer.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Footer = ({ classes, children, dense, className }) => (
  <div
    className={classNames(
      classes.container,
      { [classes.dense]: dense },
      className
    )}>
    {children}
  </div>
)

export default injectSheet(styles)(Footer)
